module.exports = __webpack_public_path__ + "img/sdk8.2ba5dd30.png";